import React from 'react';

import { Block } from '@uncinc/react-drupal-core';

const ParagraphCtaBlockReference = ({ id, entity }) => {
  const block = entity.toJS();

  return (
    <div id={id} className="Paragraph CTABlockReference">
      <Block id={block.field_cta_block[0].target_id} />
    </div>
  );
};

export default ParagraphCtaBlockReference;
